import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function UsersIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.4 3.275a2.64 2.64 0 0 1 1.5 2.372c0 1.04-.611 1.939-1.5 2.372m1.2 3.079c.907.402 1.723 1.058 2.4 1.902M2 13c1.168-1.457 2.754-2.353 4.5-2.353S9.832 11.543 11 13M9.2 5.647c0 1.462-1.209 2.647-2.7 2.647S3.8 7.11 3.8 5.647 5.009 3 6.5 3s2.7 1.185 2.7 2.647" /></svg>
  );
}

export default UsersIcon;
